import { getColumnTitle } from "../tableHelpers";

type TableDictionary = Record<string, string>;
type TableDictionaryMap = Record<string, TableDictionary>;

const dictionaryModules = import.meta.glob<{ default: TableDictionary }>(
  "./files/*-dictionary.json",
  {
    eager: true,
  },
);

const tableDictionaryMap: TableDictionaryMap = Object.entries(
  dictionaryModules,
).reduce<TableDictionaryMap>((acc, [path, module]) => {
  const configKey = path
    .replace("./files/", "")
    .replace("-dictionary.json", "");

  if (configKey && module?.default) {
    acc[configKey] = module.default;
  }

  return acc;
}, {});

export const useTableDictionary = (pageName?: string) => {
  const dictionary = pageName ? tableDictionaryMap[pageName] : undefined;

  return {
    dictionary,
    columnsTitleCreator: (column: string) => getColumnTitle(column, dictionary),
  };
};
